module.exports = __webpack_public_path__ + "static/send_message-df518de8ef79f920a1af2510503406d1.webp";